export default __webpack_public_path__ + "static/media/profile2.a9136072.png";